// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__2twa3"};